var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({staticClass:"cLogo",attrs:{"src":"/images/bpor.jpg","alt":"logo"},on:{"click":function($event){return _vm.$emit('click', $event)}}},'img',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }